export default [
	{
		tenantId: '3f5a9c8a-4a78-4723-a9bd-3f43b18fe5be',
		settings: {
			workflow: {
				professionalProfile: {
					hideRegistrationBodyField: true,
					hideRegistrationNumberField: true,
					minimumHourlyRate: 35,
					defaultShiftStartTime: '00:00',
					defaultShiftEndTime: '23:45',
					defaultCompanyLanguages: ['English'],
					workExperienceIcon: 'mdi-glass-wine',
					showExpandedShiftSummary: true,
					allowOptionalFormalTraining: true,
					professionalCalendar: {
						eventColors: {
							applicationSent: 'yellow darken-1',
						},
					},
				},
				companyProfile: {
					seeAllProfessionCategories: true,
					hideIndustryPicker: true,
					defaultIndustry: 'Venue',
					showEstablishmentType: true,
					establishmentTypeRequired: true,
					showAdditionalSkillsFilter: true,
					matchProfessionOrSkills: true,
					filterByEstablishmentType: true,
				},
			},
			navigation: {
				hideTutorials: true,
			},
			links: {
				faq: 'https://www.zenzishift.com/worker-faq',
				blog: 'https://www.zenzishift.com/blog',
				contact: 'https://www.zenzishift.com/contact',
				whatsappNumber: '',
				whatsappDefaultMessage: 'Hi, I would like to know more about Zenzi.',
			},
			brandImages: {
				placeholders: {
					professional: 'zenzishift/seeker-profile-placeholder.png',
					company: 'zenzishift/venue-profile-placeholder.png',
				},
			},
		},
	},
	{
		tenantId: '76081da2-5fdd-47b0-8caf-2c337ea3bf9f',
		settings: {
			workflow: {
				professionalProfile: {
					hideRegistrationBodyField: true,
					hideRegistrationNumberField: true,
					minimumHourlyRate: 35,
					defaultShiftStartTime: '00:00',
					defaultShiftEndTime: '23:45',
					defaultCompanyLanguages: ['English'],
					workExperienceIcon: 'mdi-glass-wine',
					showExpandedShiftSummary: true,
					allowOptionalFormalTraining: true,
					professionalCalendar: {
						eventColors: {
							applicationSent: 'yellow darken-1',
						},
					},
				},
				companyProfile: {
					seeAllProfessionCategories: true,
					hideIndustryPicker: true,
					defaultIndustry: 'Venue',
					showEstablishmentType: true,
					establishmentTypeRequired: true,
					showAdditionalSkillsFilter: true,
					matchProfessionOrSkills: true,
					filterByEstablishmentType: true,
				},
			},
			navigation: {
				hideTutorials: true,
			},
			links: {
				faq: 'https://www.zenzishift.com/worker-faq',
				blog: 'https://www.zenzishift.com/blog',
				contact: 'https://www.zenzishift.com/contact',
				whatsappNumber: '',
				whatsappDefaultMessage: 'Hi, I would like to know more about Zenzi.',
			},
			brandImages: {
				placeholders: {
					professional: 'zenzishift/seeker-profile-placeholder.png',
					company: 'zenzishift/venue-profile-placeholder.png',
				},
			},
		},
	},
];
